<template>
    <div style="display: flex; height: 100%;">
        <v-row style="margin: 0px;">
            <v-col cols="8" class="tableau">
                <v-data-table class="historiqueTable" :item-class="getRowClass" :items="historique"
                    :headers="headerHistorique" :items-per-page="-1" fixed-header hide-default-footer
                    @click:row="editItem">
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_historique_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click.stop="deleteItem(item)">
                            mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

            </v-col>
            <v-col cols="4" class="formulaire">
                <div class="champs">
                    <div>
                        {{ $t('_nom_') }}
                    </div>
                    <div class="input">
                        <v-text-field outlined class="inputField" v-model="reponse.nom.value">
                        </v-text-field>
                    </div>
                </div>
                <div class="champs">
                    <div>
                        {{ $t('_type_d_onduleur_') }} (*)
                    </div>
                    <div class="inputField">
                        <select class="createSelect" v-model="reponse.type.value">
                            <option disabled value=""> </option>
                            <option v-for="(opt, index) in onduleurs" :value="opt.modele" :key="index"> {{ opt.modele }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="champs">
                    <div>
                        {{ $t("_date_d_installation_") }} (*)
                    </div>
                    <div class="input">
                        <input class="date" type="date" v-model="reponse.dateInstall.value" />
                    </div>
                </div>
                <div class="champs">
                    <div>
                        {{ $t("_date_de_fin_d_exloitation_") }}
                    </div>
                    <div class="input">
                        <input class="date" type="date" v-model="reponse.dateFinExploit.value" />
                    </div>
                </div>
                <div v-if="this.reponse.dateFinExploit.value !== '' && this.reponse.dateInstall.value !== '' && this.reponse.dateFinExploit.value < this.reponse.dateInstall.value"
                    class="warn"> {{ $t("_attention_la_date_de_fin_d_exploit_") }} </div>

                <div class="champs">
                    <div>
                        {{ $t("_commentaire_") }}
                    </div>
                    <div class="input">
                        <v-text-field outlined class="inputField" v-model="reponse.comment.value">
                        </v-text-field>
                    </div>
                </div>

                <div v-if="this.edition === false" style="width: 50%;">
                    <div class="nom">{{ $t("_nombre_d_occurence_") }}</div>
                    <v-text-field label="" outlined class="inputField" v-model="nbDOccurence" maxlength="2"
                        onkeypress="return (event.charCode !=8 && event.charCode ==0 || ( event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))"></v-text-field>
                </div>
                <v-btn v-if="!edition" :disabled="!rempli"
                    style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                    @click="addData()">
                    {{ $t('_ajouter_') }}
                </v-btn>
                <div v-else>
                    <v-btn :disabled="!rempli"
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="editData()">
                        {{ $t('_modifier_') }}
                    </v-btn>
                    <v-btn
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="cancelEdit()">
                        {{ $t('_annuler_') }}
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    props: {
        initHistorique: {
            required: false,
        },
        onduleurs: {
            required: true,
        },
        initCalepinage: {         //est modifier si un historique y figurant est supprimé
            required: false,
        },

    },

    //initialise la date d'instalation à la date du jour, pre rempli le formulaire et calepinage avec les données deja enregistées
    mounted() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');     // Jour (2 chiffres)
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (2 chiffres, attention +1)
        const year = today.getFullYear();
        this.reponse.dateInstall.value = `${year}-${month}-${day}`
        this.reponseVide.dateInstall.value=`${year}-${month}-${day}`
        if (this.initHistorique !== undefined && this.initHistorique !== null)
            this.historique = this.initHistorique
        if (this.initCalepinage !== undefined && this.initCalepinage !== null)
            this.calepinage = this.initCalepinage
    },

    data() {
        return {
            historique: [],
            calepinage: [],
            headerHistorique: [
                { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
                { key: 'nom', text: this.$t('_nom_'), value: 'nom' },
                { key: 'type', text: this.$t('_type_d_onduleur_'), value: 'type' },
                { key: 'dateInstall', text: this.$t('_date_d_installation_'), value: 'dateInstall' },
                { key: 'dateFinExploit', text: this.$t('_date_de_fin_d_exloitation_'), value: 'dateFinExploit' },
                { key: 'comment', text: this.$t('_commentaire_'), value: 'comment' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            rempli: false,
            edition: false,
            indexEdite: null,

            nbDOccurence: 1,

            reponse: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "nom": {
                    "value": "",
                    "required": false,
                },
                "type": {
                    "value": "",
                    "required": true,
                },
                "dateInstall": {
                    "value": "",
                    "required": true,
                },
                "dateFinExploit": {
                    "value": "",
                    "required": false,
                },
                "comment": {
                    "value": "",
                    "required": false,
                },

            },
            reponseVide: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "nom": {
                    "value": "",
                    "required": false,
                },
                "type": {
                    "value": "",
                    "required": true,
                },
                "dateInstall": {
                    "value": "",
                    "required": true,
                },
                "dateFinExploit": {
                    "value": "",
                    "required": false,
                },
                "comment": {
                    "value": "",
                    "required": false,
                }
            },
        }
    },
    methods: {
        editItem(item) {
            this.edition = true
            this.indexEdite = this.historique.indexOf(item)
            for (var champ in item) {
                this.reponse[champ].value = item[champ]
            }

        },

        cancelEdit() {
            this.edition = false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide) {
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }

            })
        },

        getRowClass(item) {
            let index = this.historique.indexOf(item)
            return index === this.indexEdite ? 'highlighted-row' : ''
        },

        editData() {
            if (this.reponse.nom.value === this.reponseVide.nom.value)
                this.reponse.nom.value = "inv-" + this.reponse.id.value
            for (var champ in this.reponse) {
                this.historique[this.indexEdite][champ] = this.reponse[champ].value
            }
            this.edition = false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide) {
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }

            })
            this.$emit("answer", { "reponse": this.historique, "calepinage: ": this.calepinage })
        },

        addData() {
            if (this.rempli) {
                for (let i = 0; i < this.nbDOccurence; i++) {
                    var justValeurs = {}
                    this.reponse.id.value = this.historique.length + 1
                    if (this.reponse.nom.value === this.reponseVide.nom.value)
                        justValeurs["nom"] = "inv-" + this.reponse.id.value
                    else
                        if (this.nbDOccurence === 0)
                            justValeurs["nom"] = this.reponse.nom.value
                        else
                            justValeurs["nom"] = this.reponse.nom.value + (i + 1)
                    for (var champ in this.reponse) {
                        if (champ !== "nom") {
                            justValeurs[champ] = this.reponse[champ].value
                        }
                    }
                    this.historique.push(justValeurs)
                }

                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
                this.nbDOccurence = 1
            }
            this.$emit("answer", { "reponse": this.historique, "calepinage: ": this.calepinage })
        },
        deleteItem(item) {
            this.historique.splice(this.historique.indexOf(item), 1)
            this.$nextTick(() => {
                for (var i = 0; i < this.historique.length; i += 1) {
                    this.historique[i].id = i + 1
                }
            })

            //a chaque suppression, calepinage est refait pour supprimer les lignes contenant cet onduleur
            let newCalepinage = []
            this.calepinage.forEach(calp => {
                if (calp.idOnduleur !== item.id) {
                    if (calp.idOnduleur > item.id)
                        calp.idOnduleur -= 1
                    newCalepinage.push(calp)
                }


            })
            this.$nextTick(() => {
                for (var i = 0; i < newCalepinage.length; i += 1) {
                    newCalepinage[i].id = i + 1
                }
            })
            this.calepinage = newCalepinage

            if (this.edition === true) {
                this.edition = false
                this.indexEdite = null
                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
            }
            this.$emit("answer", { "reponse": this.historique, "calepinage": this.calepinage })
        },
    },
    watch: {
        //indique si tout les champs obligatoires sont rempli ou pas
        reponse: {
            handler() {
                let nouveauRempli = true
                for (var champs in this.reponse) {
                    if (this.reponse[champs].required === true && this.reponse[champs].value === "") {
                        nouveauRempli = false
                    }
                }
                if (this.reponse["dateFinExploit"].value !== '' && this.reponse["dateInstall"].value !== '' && this.reponse["dateInstall"].value > this.reponse["dateFinExploit"].value) {
                    nouveauRempli = false
                }

                this.rempli = nouveauRempli
            },
            deep: true
        },
        historique: {
            //si il y a plus de un onduleur renseigné dans l'inventaite, le bouton suivant est activé
            handler() {
                if (this.historique.length > 0) {
                    this.$emit('enable')
                }
                else {
                    this.$emit('disable')
                }
            },
            deep: true
        }
    }

}

</script>

<style scoped>
.tableau {
    align-content: center;
    height: 66vh;
}

.tableau .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
    overflow-x: auto;
}

.tableau .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.historiqueTable {
    height: 65vh;
}

.historiqueTable>>>.highlighted-row {
    background-color: #d9d9d9 !important;
}

.formulaire {
    align-content: center;
}

.v-messages {
    min-height: 0;
    height: 0;
}

.unit {
    padding: 0;
    padding-left: 12px;
    align-content: center;
    font-weight: normal;
}

.complement {
    font-size: 0.7rem;
    font-weight: normal;
    align-content: center;
}
</style>